/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Cta_BodyInputs */

const en_control_cta_body = /** @type {(inputs: Control_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring your combat choices together in one shareable plan. No invented scores or damage calculations.`)
};

const zh_control_cta_body = /** @type {(inputs: Control_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将战斗能力选择汇总为可分享的方案，不编造评分或伤害数据。`)
};

/**
* | output |
* | --- |
* | "Bring your combat choices together in one shareable plan. No invented scores or damage calculations." |
*
* @param {Control_Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_cta_body = /** @type {((inputs?: Control_Cta_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Cta_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_cta_body(inputs)
	return zh_control_cta_body(inputs)
});
export { control_cta_body as "control.cta.body" }